import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

import {
  Row,
  SpinnerLoader,
  HelperViewStatus
} from '@warrenbrasil/nebraska-web';
import { Accordion } from '@/modules/common/components/Accordion';
import { Money } from '@/modules/common/components/Money';
import { PerformanceDetails } from '@/modules/common/components/PerformanceDetails';

import {
  getPerformanceHistoryDetail,
  IDefaultProps,
  IPerformanceDetailResponse
} from '@/modules/investments/services/investments';

interface Props {
  historyOverview: IDefaultProps[];
  updatedAt: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PerformanceHistoryAccordion',
  props: {
    historyOverview: null,
    updatedAt: null
  },
  setup(__props: any) {



const currentIndex = ref(-1);
const isLoading = ref(true);
const hasError = ref(false);
const summaryDetails = ref({} as IPerformanceDetailResponse);

async function openPeriodHistory(
  index: number,
  eventPayload: boolean,
  year: string
) {
  if (eventPayload) {
    currentIndex.value = index;
    await getPerformanceDetail(year);
  } else {
    currentIndex.value = -1;
  }
}

async function getPerformanceDetail(year: string) {
  try {
    hasError.value = false;
    isLoading.value = true;

    summaryDetails.value = await getPerformanceHistoryDetail(year);
  } catch (error) {
    console.error(error);
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

return { __sfc: true,currentIndex, isLoading, hasError, summaryDetails, openPeriodHistory, getPerformanceDetail, Row, SpinnerLoader, HelperViewStatus, Accordion, Money, PerformanceDetails }
}

})